import QuillField from '@/components/QuillField.tsx';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { TestimonialsSectionItemData } from '@superfunnel/types';
import Button from '@superfunnel/ui-core/v2/Button';

interface ITestimonials {
  testimonials?: TestimonialsSectionItemData[];
  onEditClick: (testimonial: TestimonialsSectionItemData) => void;
  onDeleteClick: (testimonial: TestimonialsSectionItemData) => void;
}
export const Testimonials = ({
  testimonials,
  onEditClick,
  onDeleteClick,
}: ITestimonials) => {
  if (!testimonials?.length) {
    return <div className="text-base-500 font-inter text-sm/[1]">None</div>;
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row flex-wrap gap-4">
        {testimonials?.map((testimonial) => (
          <div key={testimonial.id} className="group relative">
            <Testimonial testimonial={testimonial} />
            <div className="invisible absolute top-0 flex h-full w-full items-start justify-end group-hover:visible">
              <Button
                size="icon-sm"
                onClick={() => onEditClick(testimonial)}
                className="absolute -top-2 -right-2"
              >
                <PencilIcon className="h-4 w-4" />
              </Button>
              <Button
                size="icon-sm"
                color="negative"
                onClick={() => onDeleteClick(testimonial)}
                className="absolute top-6 -right-2"
              >
                <TrashIcon className="h-4 w-4" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

function Testimonial({
  testimonial,
}: {
  testimonial: TestimonialsSectionItemData;
}) {
  return (
    <figure className="rounded-2xl bg-white shadow-lg ring-1 ring-gray-900/5 sm:col-span-2 xl:col-start-2 xl:row-end-1">
      <blockquote className="text max-w-md min-w-[300px] p-2 leading-6 font-semibold tracking-tight text-gray-900 sm:p-4 sm:leading-8">
        <QuillField value={testimonial.body} readOnly noDesign />
      </blockquote>
      {testimonial.author ? (
        <figcaption className="flex flex-wrap items-center gap-x-4 gap-y-4 border-t border-gray-900/10 px-6 py-4 sm:flex-nowrap">
          <img
            className="h-10 w-10 flex-none rounded-full bg-gray-50"
            src={testimonial.author?.image?.url}
            alt=""
          />
          <div className="flex-auto">
            <div className="font-semibold">
              <QuillField
                value={testimonial.author?.name || 'Anonymous'}
                readOnly
                noDesign
              />
            </div>

            <div className="text-gray-600">
              <QuillField
                value={testimonial.author?.title || 'anonymous'}
                readOnly
                noDesign
              />
            </div>
          </div>
          <img
            className="h-10 w-auto flex-none"
            src={testimonial.author?.logo?.url}
            alt=""
          />
        </figcaption>
      ) : (
        <></>
      )}
    </figure>
  );
}
